module.exports = __webpack_public_path__ + "assets/img/yongjing.5a9ba8dd.png";